// extracted by mini-css-extract-plugin
export default {"box":"Value_box__36rLX","unit":"Value_unit__mUA8f","on_top":"Value_on_top__XNnAd"};